import React, { useState, useMemo, useRef } from 'react'
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import countryList from 'react-select-country-list';
import { SlCalender } from "react-icons/sl";
import { MdCurrencyPound } from "react-icons/md";
import { MdOutlinePercent } from "react-icons/md";
import { validateInput, validateNumericInput, validateTwoDates } from '../utils/validate';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

// InputField Component
export const InputField = ({ label, htmlFor, placeholder, value, onChange, disabled, type = "text", keyListner }) => (
    <>
        <div key={label} className="input-field-row">
            <div className="label_div"><label htmlFor={htmlFor}>{label}</label></div>
            <div className="input_box_div">
                <input
                    className="input_style"
                    type={type}
                    id={htmlFor}
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => { onChange(e); validateInput(e, type) }}
                    disabled={disabled}
                    onKeyDown={keyListner}
                />
            </div>
        </div>
        <p id={`error-message-${htmlFor}`} className='error_message'></p>
    </>
);

// InputFieldWithDate Component
export const InputFieldWithDate = ({ label, htmlFor1, htmlFor2, placeholder1, nameValue, dateValue, onChange, onDateChange, type = "text" }) => {
    console.log("nameValue", nameValue, "dateValue ", dateValue);
    return (
        <>
            <div key={label} className="input-field-row">
                <div className="label_div"><label htmlFor={htmlFor1}>{label}</label></div>
                <div className="date_picker_data_div">
                    <div className="name_div">
                        <input
                            className="input_style"
                            type="text"
                            id={htmlFor1}
                            placeholder={placeholder1}
                            value={nameValue}
                            onChange={onChange}
                            onInput={(e) => validateInput(e, type)}
                        />
                    </div>
                    <div className="date_div">
                        <DatePicker
                            value={dateValue}
                            onChange={(e) => { onDateChange(e); validateTwoDates(e, htmlFor2) }}
                            showLeadingZeros
                            id={`${htmlFor2}`}
                            format="dd/MM/yyyy"
                            dayPlaceholder='DD'
                            monthPlaceholder='MM'
                            yearPlaceholder='YYYY'
                            maxDate={htmlFor2.includes('dateOfBirth') || htmlFor2.includes('nameChangeDate') ? new Date() : null}
                            clearIcon={<div />}
                            calendarIcon={<SlCalender style={{ fontSize: '15px', color: 'gray' }} />}
                        />
                    </div>
                </div>
            </div>
            <div style={{ width: '100%', display: 'flex' }}>
                <div className='empty_div'><p></p></div>
                <div className='error_msg_div' style={{ display: 'flex' }}>
                    <div className='name_error_msg'>
                        <p id={`error-message-${htmlFor1}`} className='error_message'></p>
                    </div>
                    <div className='date_error_msg'>
                        <p id={`date-error-message-${htmlFor2}`} className='error_message'></p>
                    </div>
                </div>
            </div>
        </>
    );
};

// ButtonComponent
export const ButtonComponent = ({ tooltipId, name, onClick, icon, disabled = false }) => (
    <div className="btn-div">
        <button data-tooltip-id={tooltipId} type="button" className="proceed-btn" onClick={onClick} disabled={disabled} >
            {name}
            {icon && <span style={{ marginTop: '10px' }}>{icon}</span>}
        </button>
    </div>
);

// DatePicker Component
export const DatePickerComponent = ({ htmlFor, label, value, onChange }) => {
    const datePickerRef = useRef(null);
    const fieldsWithMaxDate = [
        'dateOfBirth',
        'selfEmploymentDuration',
        'PassportIssueDate',
        'employmentStartDate',
        'AccountOpenDate'
    ];
    return (
        <>
            <div className="input-field-row">
                <div className='label_div'> <label htmlFor={htmlFor}>{label}</label></div>
                <div className="calender_div">
                    <DatePicker
                        ref={datePickerRef}
                        id={`${htmlFor}`}
                        value={value}
                        onChange={(e) => { onChange(e); validateTwoDates(e, htmlFor) }}
                        showLeadingZeros
                        format="dd/MM/yyyy"
                        dayPlaceholder=' DD '
                        monthPlaceholder=' MM '
                        yearPlaceholder=' YYYY '
                        maxDate={fieldsWithMaxDate.some(field => htmlFor.includes(field)) ? new Date() : null}
                        clearIcon={<div />}
                        calendarIcon={<SlCalender style={{ fontSize: '15px', color: 'gray' }} />}
                    />
                </div>
            </div>
            <p id={`date-error-message-${htmlFor}`} className='error_message'></p>
        </>
    );
};

// SelectBox Component
export const SelectBox = ({ label, htmlFor, options, name, onChange, value, placeholder, styles }) => {
    return (
        <>
            <div className="input-field-row">
                <div className="label_div"> <label htmlFor={htmlFor}>{label}</label> </div>
                <div className="input_box_div">
                    <Select options={options}
                        id={htmlFor}
                        value={value}
                        onChange={(selectedOption) => onChange(selectedOption)}
                        name={name}
                        placeholder={placeholder}
                        styles={styles}
                        isSearchable={htmlFor === 'nationality' || htmlFor === 'otherTitle' || htmlFor === 'passportIssuingCountry' ? true : false}
                    />
                </div>
            </div>
            <p id={`error-message-${htmlFor}`} className='error_message'></p>
        </>
    );
};

//address durations 
export const TimeDuration = ({ label, htmlFor, fields, onChange }) => {
    const renderSelect = (name, value, optionArray, index, style) => (
        <Select
            key={index}
            className="time_duration"
            name={name}
            onChange={(selectedOption) => onChange(selectedOption, name)}
            value={value}
            placeholder={name}
            options={optionArray}
            styles={style}
        />
    );
    return (
        <>
            <div className="input-field-row">
                <div className="label_div"> <label htmlFor={htmlFor}>{label}</label> </div>
                <div className="time_duration_div">
                    {fields.map((field, index) =>
                        renderSelect(field.name, field.value, field.options, index, field.style)
                    )}
                </div>
            </div>
            <p id={`error-message-${htmlFor}`} className='error_message'></p>
        </>
    );
};

//country picker
export const CountryPicker = () => {
    const [value, setValue] = useState('')
    const options = useMemo(() => countryList().getData(), [])

    const changeHandler = value => {
        setValue(countryList().getValue(value))
    }
    return <Select options={options} value={value} onChange={changeHandler} />
};

//price component
export const PriceInputBox = ({ label, htmlFor, placeholder, value, onChange }) => (
    <>
        <div key={label} className="input-field-row">
            <div className="label_div"><label htmlFor={htmlFor}>{label}</label></div>
            <div className="input_box_div">
                <div className="input_container">
                    <span className="currency_icon"><MdCurrencyPound style={{ color: 'gray' }} /></span>
                    <input
                        style={{ paddingLeft: '15px' }}
                        className="input_style"
                        type='number'
                        id={htmlFor}
                        placeholder={placeholder}
                        value={value}
                        onChange={onChange}
                        onInput={(e) => validateNumericInput(e)}
                    />
                </div>
            </div>
        </div>
        <p id={`error-message-${htmlFor}`} className='error_message'></p>
    </>
);

export const PercentageInputBox = ({ label, htmlFor, placeholder, value, onChange }) => (
    <>
        <div key={label} className="input-field-row">
            <div className="label_div"><label htmlFor={htmlFor}>{label}</label></div>
            <div className="input_box_div">
                <div className="input_container">
                    <span className="percentage_icon"><MdOutlinePercent color='gray' /></span>
                    <input
                        style={{ paddingLeft: '15px' }}
                        className="input_style"
                        type="number"
                        id={htmlFor}
                        placeholder={placeholder}
                        value={value}
                        onChange={onChange}
                        onInput={(e) => validateInput(e, "percentage")}
                    />
                </div>
            </div>
        </div>
        <p id={`error-message-${htmlFor}`} className='error_message'></p>
    </>
);

const CustomInput = React.forwardRef(({ htmlFor, placeholder, value, onChange, disabled }, ref) => (
    <input
        ref={ref}
        className="input_style"
        id={htmlFor}
        placeholder={placeholder}
        value={value || ''}
        onChange={onChange}
        disabled={disabled}

    />
));

export const PhoneNumberInput = ({ label, htmlFor, placeholder, value, onChange, keyListner, disabled, error }) => {
    return (
        <>
            <div key={label} className="input-field-row">
                <div className="label_div"><label htmlFor={htmlFor}>{label}</label></div>
                <div className="input_box_div">
                    <div className="input_container">
                        <PhoneInput
                            disabled={disabled}
                            defaultCountry="IN"
                            international
                            value={value || ''}
                            onKeyDown={keyListner}
                            onChange={(phoneNumber) => onChange(phoneNumber || '')}
                            inputComponent={CustomInput}
                            numberInputProps={{ htmlFor, placeholder }}
                        />
                    </div>
                </div>
            </div>
            {<p id={`error-message-${htmlFor}`} className="error_message">{error}</p>}
        </>
    );
};

export const FilterButtonComponent = ({ name, isActive, onClick }) => (
    <button type="button" className={`filter-btn ${isActive ? "active" : ""}`} onClick={onClick} >
        {name}
    </button>
);
